import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 17.2 18"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M14.95 3.93H2.25c-.69 0-1.25.58-1.25 1.3v7.98c0 .72.56 1.3 1.25 1.3h12.7c.69 0 1.25-.58 1.25-1.3V5.23c.01-.72-.56-1.3-1.25-1.3zm-3.82 4.85 4.43-3.79c.03.07.05.15.05.23v7.98c0 .07-.02.13-.04.2l-4.44-4.62zm3.82-4.25c.06 0 .12.02.18.04L8.6 10.15 2.07 4.57c.06-.02.12-.04.18-.04h12.7zM1.63 13.41a.647.647 0 0 1-.04-.2V5.23c0-.08.02-.16.05-.23l4.43 3.79-4.44 4.62zm.62.5c-.08 0-.15-.02-.22-.05l4.5-4.69 1.88 1.6c.06.05.13.07.19.07s.14-.02.19-.07l1.88-1.6 4.5 4.69c-.07.03-.14.05-.22.05H2.25z"
    }, null, -1)
  ])))
}
export default { render };